import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

export default function FounderStorySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="founder-story"
      className="py-10 md:py-20 bg-white w-full"
      ref={ref}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              From Student to Successful Professional to MIT Founder
            </h2>
            <div className="space-y-6 text-base md:text-xl font-medium text-gray-600 text-center">
              <p>
                Like many international and domestic students, our founder and
                the core team faced the overwhelming complexity of navigating
                education systems, visa requirements, and financial planning.
              </p>
              <p>
                After experiencing firsthand the lack of transparent, accessible
                guidance, they realized that thousands of talented students were
                missing opportunities simply due to information gaps and
                systemic barriers.
              </p>
              <p>
                OneGrad was born from this personal journey – a mission to
                democratize education and ensure every student has the tools,
                knowledge, and support to achieve their global dreams.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
